module.exports = __webpack_public_path__ + "img/giftCertificate1_3.438824d0.png";